import React from "react";
import beeLogo  from "../../assests/images/footer-logo.png";
import './Footer.css'
import facebook from '../../assests/images/facebook.png'
import youtube from '../../assests/images/youtube.png'
import twitter from "../../assests/images/twitter.jpg";
import phone from '../../assests/images/phone.png'
import envelop from '../../assests/images/envelop.png'
import { Link } from "react-router-dom";

const Footer = () => {
    return (
      <>
        <>
          <div className="container-fluid p-0">
            <div className="footer-color py-5">
              <div className="container pt-5">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <div className="footer-section">
                      <img src={beeLogo} alt="logo" width={100} />
                      <p className="pe-3">
                        A solution that worked well for their flower stand. At
                        the end of the day, your small business is unique
                        research.
                      </p>
                    </div>
                    <div className="d-flex align-items-center">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-3"
                        href="https://www.facebook.com/"
                      >
                        <img src={facebook} alt="facebook"></img>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-3"
                        href="https://www.youtube.com/"
                      >
                        <img src={youtube} alt="facebook"></img>
                      </a>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="me-3"
                        href="https://twitter.com/"
                      >
                        <img
                          src={twitter}
                          className="twitter_icon"
                          alt="twitter"
                        ></img>
                      </a>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-4">
                    <div className="menu-links">
                      <h4>Useful Links</h4>
                      <ul className="menus-name mt-3 p-0">
                        <li className="mb-2">
                          <Link
                            to="/about"
                            className="text-decoration-none"
                          >
                            About us
                          </Link>
                        </li>
                        <li className="mb-2">
                          <Link
                            to="/Career"
                            className="text-decoration-none"
                          >
                            Career{" "}
                          </Link>
                        </li>
                        <li className="mb-2">
                          <Link
                            to="/FinService"
                            className="text-decoration-none"
                          >
                            Loans
                          </Link>
                        </li>
                        <li className="mb-2">
                          <Link
                            to="/contact"
                            className="text-decoration-none"
                          >
                            Contact Us{" "}
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-4">
                    <div className="menu-links">
                      <h4>Get in touch</h4>
                      <ul className="menus-name mt-3 p-0">
                       
                        <li className="mb-3">
                          <a
                            className="text-decoration-none"
                            href="tel:+237650520150"
                          >
                            <img className="me-2" src={phone} alt="phone"></img>{" "}
                            +237650520150
                          </a>
                        </li>
                        <li className="mb-3">
                          <a
                            className="text-decoration-none"
                            href="mailto:+237650520150"
                          >
                            <img
                              className="me-2"
                              src={envelop}
                              alt="phone"
                            ></img>{" "}
                            info@beegroup.cm
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-12">
                    <div className="text-center copy-right mt-5">
                      <p>Copyright (c) 2023 . BeeGroup</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      </>
    );
}

export default Footer;